"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var react_1 = require("@headlessui/react");
var outline_1 = require("@heroicons/react/24/outline");
var axios_1 = __importDefault(require("axios"));
var react_2 = __importStar(require("react"));
require("../../../index.css");
var iconButton_1 = require("../../action/iconButton");
var textButton_1 = require("../../action/textButton");
var popUp_1 = require("../../advanced/popUp");
var display_1 = require("../../data/display");
var link_1 = require("../../structure/link");
var defaultLimit = 10;
var defaultPageSize = 5;
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table() {
        var _this = this;
        var _a, _b, _c;
        _this = _super.apply(this, arguments) || this;
        //INFO: Trigger state is here to re-render checkbox inputs in td
        _this.state = {
            trigger: false,
            addData: false,
            addDataValue: {},
            referenceLoading: false,
            referencesOptions: [],
            editDataRowId: "",
            editDataHeaderKey: "",
            editDataValue: {},
            editDataIsLoading: false,
        };
        _this.supportedHeaderType = [
            "string",
            "contact",
            "number",
            "boolean",
            "list",
            "multipleList",
            "address",
        ];
        _this.dbModule = ((_a = _this.props.devSettings) === null || _a === void 0 ? void 0 : _a.server) === "firebase"
            ? (_b = _this.props.lib) === null || _b === void 0 ? void 0 : _b.firebase
            : (_c = _this.props.lib) === null || _c === void 0 ? void 0 : _c.axios;
        _this.addDataInputRefs = [];
        _this.editDataInputRefs = [];
        _this.setReferencesOptions = function (options) {
            _this.setState({ referencesOptions: options });
        };
        _this.setReferenceLoading = function (value) {
            _this.setState({ referenceLoading: value });
        };
        //=====================================================================================
        //SECTION: Addable & Editable Feature
        //=====================================================================================
        _this.componentDidMount = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            if ((_a = _this.props.addable) === null || _a === void 0 ? void 0 : _a.active)
                _this.handleCreateFormInputRefs("add");
            if (((_b = _this.props.addable) === null || _b === void 0 ? void 0 : _b.active) || ((_c = _this.props.editable) === null || _c === void 0 ? void 0 : _c.active)) {
                var tableHeaderAsDataStructure = _this.handleConvertTableHeaderToDataStructure(_this.props.header);
                (0, display_1.handleRetrieveReferenceOptions)({}, tableHeaderAsDataStructure, (_d = _this.props.lib) === null || _d === void 0 ? void 0 : _d.axios, (_f = (_e = _this.props.devSettings) === null || _e === void 0 ? void 0 : _e.server) !== null && _f !== void 0 ? _f : "mongoServer", (_h = (_g = _this.props.devSettings) === null || _g === void 0 ? void 0 : _g.dbEndpoint) !== null && _h !== void 0 ? _h : "", (_k = (_j = _this.props.devSettings) === null || _j === void 0 ? void 0 : _j.dbAPIToken) !== null && _k !== void 0 ? _k : "", _this.setReferencesOptions);
            }
        };
        _this.handleConvertTableHeaderToDataStructure = function (header) {
            return header.map(function (eachHeader) {
                var _a;
                return (__assign(__assign({}, eachHeader), { id: eachHeader.key, name: eachHeader.title, type: (_a = eachHeader.type) !== null && _a !== void 0 ? _a : "string" }));
            });
        };
        _this.handleValidateTableHeaderType = function (header) {
            var filteredHeader = header.filter(function (item) { return item.key !== "id"; });
            if (filteredHeader.length <= 0)
                return false;
            var supported = true;
            filteredHeader.map(function (eachHeader) {
                if (eachHeader.type) {
                    if (!_this.supportedHeaderType.includes(eachHeader.type))
                        supported = false;
                }
                return null;
            });
            return supported;
        };
        _this.handleCreateFormInputRefs = function (type) {
            var formInputRefs = [];
            _this.props.header.map(function (eachHeader) {
                if (eachHeader.key !== "id")
                    formInputRefs.push((0, react_2.createRef)());
                return null;
            });
            if (type === "add")
                _this.addDataInputRefs = formInputRefs;
            else
                _this.editDataInputRefs = formInputRefs;
        };
        _this.handleCheckFormInputRefs = function (type) { return __awaiter(_this, void 0, void 0, function () {
            var completedCond, formInputRefs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        completedCond = true;
                        formInputRefs = type === "add" ? this.addDataInputRefs : this.editDataInputRefs;
                        if (!(formInputRefs.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(formInputRefs.map(function (eachRef) { return __awaiter(_this, void 0, void 0, function () {
                                var condition;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (!((_a = eachRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmit)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, eachRef.current.handleSubmit()];
                                        case 1:
                                            condition = _b.sent();
                                            if (!condition) {
                                                completedCond = false;
                                            }
                                            _b.label = 2;
                                        case 2: return [2 /*return*/, null];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, completedCond];
                }
            });
        }); };
        _this.handleGenerateClonedData = function () {
            var filteredTableHeaderList = _this.props.header.filter(function (eachHeader) { return eachHeader.key !== "id"; });
            var tableHeaderAsDataStructure = _this.handleConvertTableHeaderToDataStructure(filteredTableHeaderList);
            var value = _this.state.addData
                ? _this.state.addDataValue
                : _this.state.editDataValue;
            var clonedData = (0, display_1.handleClonedDataAttribute)(value, tableHeaderAsDataStructure);
            return clonedData;
        };
        _this.handleUpdateChangeData = function (data) {
            if (_this.state.addData)
                _this.setState({ addDataValue: data });
            else
                _this.setState({ editDataValue: data });
        };
        _this.handleOnChangeAddress = function (id, address) {
            var clonedData = _this.handleGenerateClonedData();
            clonedData[id] = address;
            _this.handleUpdateChangeData(clonedData);
        };
        _this.handleOnChangeText = function (e) {
            var clonedData = _this.handleGenerateClonedData();
            clonedData[e.target.id] = e.target.value;
            _this.handleUpdateChangeData(clonedData);
        };
        _this.handleOnChangeSelect = function (id, value) {
            var clonedData = _this.handleGenerateClonedData();
            clonedData[id] = value;
            _this.handleUpdateChangeData(clonedData);
        };
        _this.handleOnChangeDate = function (id, value) {
            var clonedData = _this.handleGenerateClonedData();
            clonedData[id] = value;
            _this.handleUpdateChangeData(clonedData);
        };
        _this.handleEditDataOnClick = function (id, headerKey, data) {
            if (_this.state.editDataRowId !== id) {
                _this.setState({
                    editDataRowId: id,
                    editDataValue: data,
                });
                _this.handleCreateFormInputRefs("edit");
            }
            _this.setState({ addData: false, editDataHeaderKey: headerKey });
        };
        _this.handleEditDataOnBlur = function (rowId, columnId, data) { return __awaiter(_this, void 0, void 0, function () {
            var completedCond;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.handleCheckFormInputRefs("edit")];
                    case 1:
                        completedCond = _c.sent();
                        if (!completedCond) return [3 /*break*/, 3];
                        if (!((_a = this.props.editable) === null || _a === void 0 ? void 0 : _a.onUpdateData)) return [3 /*break*/, 3];
                        this.setState({ editDataIsLoading: true });
                        return [4 /*yield*/, ((_b = this.props.editable) === null || _b === void 0 ? void 0 : _b.onUpdateData(rowId, columnId, data))];
                    case 2:
                        _c.sent();
                        this.setState({ editDataIsLoading: false });
                        if (this.state.editDataHeaderKey === columnId) {
                            this.setState({
                                editDataRowId: "",
                                editDataValue: {},
                                editDataHeaderKey: "",
                            });
                        }
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        //=====================================================================================
        //SECTION: Multi Select Feature
        //=====================================================================================
        _this.handleRefreshTrigger = function () {
            setTimeout(function () {
                _this.setState({ trigger: !_this.state.trigger });
            }, 50);
        };
        _this.handleSelect = function (data, event) {
            event.preventDefault();
            event.stopPropagation();
            if (_this.props.selectAll) {
                if (_this.props.handleSelectAll)
                    _this.props.handleSelectAll(false);
                _this.handleRefreshTrigger();
                return;
            }
            var clonedSelectedId = JSON.parse(JSON.stringify(_this.props.selectedIds));
            var selectedIndex = clonedSelectedId.indexOf(data.id);
            if (selectedIndex < 0)
                clonedSelectedId.push(data.id);
            else
                clonedSelectedId.splice(selectedIndex, 1);
            if (_this.props.handleSelectedIds)
                _this.props.handleSelectedIds(clonedSelectedId);
            _this.handleRefreshTrigger();
        };
        _this.handleSelectCurrentPage = function (currentPageChecked) {
            var _a, _b;
            if (_this.props.selectAll) {
                if (_this.props.handleSelectAll)
                    _this.props.handleSelectAll(false);
                return;
            }
            var clonedSelectedId = JSON.parse(JSON.stringify(_this.props.selectedIds));
            if (_this.props.paginationType === "cursor") {
                var minIndex_1 = ((_a = _this.props.pageIndex) !== null && _a !== void 0 ? _a : 0) * ((_b = _this.props.limit) !== null && _b !== void 0 ? _b : defaultLimit);
                _this.props.data.map(function (eachData, index) {
                    var _a;
                    if (index >= minIndex_1 &&
                        index < minIndex_1 + ((_a = _this.props.limit) !== null && _a !== void 0 ? _a : defaultLimit)) {
                        if (currentPageChecked) {
                            var selectedIndex = clonedSelectedId.indexOf(eachData.id);
                            if (selectedIndex >= 0)
                                clonedSelectedId.splice(selectedIndex, 1);
                        }
                        else {
                            if (!clonedSelectedId.includes(eachData.id))
                                clonedSelectedId.push(eachData.id);
                        }
                    }
                    return null;
                });
            }
            else if (_this.props.paginationType === "page") {
                _this.props.data.map(function (eachData) {
                    if (currentPageChecked) {
                        var selectedIndex = clonedSelectedId.indexOf(eachData.id);
                        if (selectedIndex >= 0)
                            clonedSelectedId.splice(selectedIndex, 1);
                    }
                    else {
                        if (!clonedSelectedId.includes(eachData.id))
                            clonedSelectedId.push(eachData.id);
                    }
                    return null;
                });
            }
            if (_this.props.handleSelectedIds)
                _this.props.handleSelectedIds(clonedSelectedId);
        };
        _this.handleSelectAllPages = function (value) {
            if (_this.props.handleSelectAll)
                _this.props.handleSelectAll(value);
            if (_this.props.handleSelectedIds)
                _this.props.handleSelectedIds([]);
        };
        //=====================================================================================
        //SECTION: Utils
        //=====================================================================================
        _this.handleClick = function (id, event) {
            if (_this.props.onClickRow) {
                _this.props.onClickRow(id);
            }
            event.preventDefault();
            event.stopPropagation();
        };
        _this.renderTableHeader = function () {
            var renderHeader = [];
            if (_this.props.checkbox) {
                if (_this.props.loading)
                    renderHeader.push(react_2.default.createElement("th", null));
                else
                    renderHeader.push(_this.renderTableHeaderCheckbox());
            }
            _this.props.header.map(function (eachHeader) {
                if (eachHeader.key !== "id") {
                    if (eachHeader.groupData && eachHeader.groupData.length > 0) {
                        renderHeader.push(react_2.default.createElement("th", null,
                            react_2.default.createElement("div", { className: "px-6 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider", key: eachHeader.key }, eachHeader.title),
                            react_2.default.createElement("div", { className: "flex flex-row" }, eachHeader.groupData.map(function (eachData) {
                                return (react_2.default.createElement("div", { key: eachData.key, className: "px-6 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-full" }, eachData.title));
                            }))));
                    }
                    else {
                        renderHeader.push(react_2.default.createElement("th", { key: eachHeader.key, className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, eachHeader.title));
                    }
                }
                return null;
            });
            if (_this.state.addData &&
                _this.handleValidateTableHeaderType(_this.props.header))
                renderHeader.push(react_2.default.createElement("th", { className: "px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Action"));
            return renderHeader;
        };
        _this.renderCheckAllSelected = function () {
            var _a, _b;
            var currentPageData = [];
            var checkDataLength = _this.props.data.length > 0;
            if (checkDataLength) {
                var totalCount_1 = 0;
                if (_this.props.paginationType === "cursor") {
                    var minIndex_2 = ((_a = _this.props.pageIndex) !== null && _a !== void 0 ? _a : 0) * ((_b = _this.props.limit) !== null && _b !== void 0 ? _b : defaultLimit);
                    _this.props.data.map(function (eachData, index) {
                        var _a;
                        if (index >= minIndex_2 &&
                            index < minIndex_2 + ((_a = _this.props.limit) !== null && _a !== void 0 ? _a : defaultLimit))
                            currentPageData.push(eachData.id);
                        return null;
                    });
                    currentPageData.map(function (eachId) {
                        var _a;
                        if ((_a = _this.props.selectedIds) === null || _a === void 0 ? void 0 : _a.includes(eachId))
                            totalCount_1 += 1;
                        return null;
                    });
                    return currentPageData.length === totalCount_1;
                }
                else if (_this.props.paginationType === "page") {
                    _this.props.data.map(function (eachData) {
                        var _a;
                        if ((_a = _this.props.selectedIds) === null || _a === void 0 ? void 0 : _a.includes(eachData.id))
                            totalCount_1 += 1;
                        return null;
                    });
                    return _this.props.data.length === totalCount_1;
                }
            }
            return false;
        };
        _this.renderTableHeaderCheckbox = function () {
            var _a, _b;
            var renderCheckbox = [];
            var currentPageData = [];
            var checkDataLength = _this.props.data.length > 0;
            if (_this.props.paginationType === "cursor") {
                if (checkDataLength) {
                    var minIndex_3 = ((_a = _this.props.pageIndex) !== null && _a !== void 0 ? _a : 0) * ((_b = _this.props.limit) !== null && _b !== void 0 ? _b : defaultLimit);
                    _this.props.data.map(function (eachData, index) {
                        var _a;
                        if (index >= minIndex_3 &&
                            index < minIndex_3 + ((_a = _this.props.limit) !== null && _a !== void 0 ? _a : defaultLimit))
                            currentPageData.push(eachData);
                        return null;
                    });
                }
            }
            checkDataLength &&
                renderCheckbox.push(react_2.default.createElement("th", { className: "w-0 px-6 py-3 bg-gray-50 text-left text-xs tracking-wider" },
                    react_2.default.createElement("div", { className: "flex relative" },
                        react_2.default.createElement("input", { onChange: _this.handleSelectCurrentPage.bind(_this, _this.renderCheckAllSelected()), checked: _this.renderCheckAllSelected() || _this.props.selectAll, name: "allSelect", type: "checkbox", className: "rounded mr-2 focus:ring-gray-50 focus:ring-offset-0 focus:outline-offset-0 border-gray-300 checked:text-primary-400" }),
                        react_2.default.createElement(popUp_1.PopUp, { anchor: "left", ctaComp: react_2.default.createElement(outline_1.ChevronDownIcon, { className: "h-4 w-4 text-gray-400 bg-gray-50", "aria-hidden": "true" }), renderComp: react_2.default.createElement("div", { className: "rounded border border-gray-300" },
                                react_2.default.createElement(react_1.Menu.Item, null,
                                    react_2.default.createElement("p", { className: "px-4 py-3 text-xs text-gray-700 text-left whitespace-nowrap font-medium hover:cursor-pointer hover:bg-gray-100", onClick: _this.handleSelectAllPages.bind(_this, true) }, "Select All in List")),
                                react_2.default.createElement(react_1.Menu.Item, null,
                                    react_2.default.createElement("p", { className: "px-4 py-3 text-xs text-gray-700 text-left whitespace-nowrap font-medium hover:cursor-pointer hover:bg-gray-100", onClick: _this.handleSelectAllPages.bind(_this, false) }, "Unselect All in List"))), lib: { Menu: react_1.Menu, Transition: react_1.Transition } }))));
            return renderCheckbox;
        };
        _this.renderTableBody = function () {
            var _a, _b;
            var renderBody = [];
            if (_this.props.loading) {
                for (var i = 0; i < 3; i++) {
                    renderBody.push(react_2.default.createElement("tr", { key: i },
                        _this.props.checkbox && react_2.default.createElement("td", null),
                        _this.props.header.map(function (eachHeader) {
                            if (eachHeader.key !== "id" && eachHeader.key !== "_id")
                                return (react_2.default.createElement("td", { key: eachHeader.key, className: "p-3" },
                                    react_2.default.createElement("div", { className: "h-6 rounded-md animate-pulse bg-gray-100" })));
                            return null;
                        })));
                }
            }
            else if (_this.props.data.length === 0) {
                renderBody.push(react_2.default.createElement("tr", { key: "noData" },
                    react_2.default.createElement("td", { className: "w-full px-6 py-4 whitespace-nowrap text-sm text-gray-900" },
                        react_2.default.createElement("div", { className: "flex" },
                            react_2.default.createElement("p", { className: "group inline-flex space-x-2 truncate text-sm text-gray-500" }, "No Data Available")))));
            }
            else {
                if (_this.props.paginationType === "cursor") {
                    var minIndex_4 = ((_a = _this.props.pageIndex) !== null && _a !== void 0 ? _a : 0) * ((_b = _this.props.limit) !== null && _b !== void 0 ? _b : defaultLimit);
                    _this.props.data.map(function (eachData, index) {
                        var _a, _b;
                        if (index >= minIndex_4 &&
                            index < minIndex_4 + ((_a = _this.props.limit) !== null && _a !== void 0 ? _a : defaultLimit)) {
                            var itemSelected = (_b = _this.props.selectedIds) === null || _b === void 0 ? void 0 : _b.includes(eachData.id);
                            renderBody.push(react_2.default.createElement("tr", { key: eachData.id, onClick: _this.handleClick.bind(_this, eachData.id), className: _this.props.onClickRow
                                    ? "cursor-pointer hover:bg-gray-100"
                                    : "" },
                                _this.props.checkbox && (react_2.default.createElement("td", { onClick: _this.handleSelect.bind(_this, eachData), className: "px-6 py-4 text-sm" },
                                    react_2.default.createElement("input", { checked: itemSelected || _this.props.selectAll, name: eachData.id, type: "checkbox", className: "z-30 rounded focus:ring-white focus:ring-offset-0 focus:outline-offset-0 border-gray-300 checked:text-primary-400" }))),
                                _this.renderRowData(eachData, index)));
                        }
                        return null;
                    });
                }
                else {
                    _this.props.data.map(function (eachData, index) {
                        var _a;
                        var itemSelected = (_a = _this.props.selectedIds) === null || _a === void 0 ? void 0 : _a.includes(eachData.id);
                        var editingRow = eachData.id === _this.state.editDataRowId &&
                            _this.state.editDataIsLoading;
                        renderBody.push(react_2.default.createElement("tr", { key: eachData.id, onClick: _this.handleClick.bind(_this, eachData.id), className: "".concat(_this.props.onClickRow && "cursor-pointer hover:bg-gray-100", " ").concat(editingRow && "animate-pulse") },
                            _this.props.checkbox && (react_2.default.createElement("td", { className: "px-6 py-4 text-sm", onClick: _this.handleSelect.bind(_this, eachData) },
                                react_2.default.createElement("input", { checked: itemSelected || _this.props.selectAll, name: eachData.id, type: "checkbox", className: "rounded focus:ring-white focus:ring-offset-0 focus:outline-offset-0 border-gray-300 checked:text-primary-400" }))),
                            _this.renderRowData(eachData, index)));
                        return null;
                    });
                }
            }
            if (_this.state.addData) {
                renderBody.push(react_2.default.createElement("tr", null, _this.renderAddDataRow()));
            }
            return renderBody;
        };
        _this.renderAddDataRow = function () {
            var renderAddDataList = [];
            if (_this.props.checkbox) {
                renderAddDataList.push(react_2.default.createElement("td", null));
            }
            var filteredTableHeaderList = _this.props.header.filter(function (eachHeader) { return eachHeader.key !== "id"; });
            var tableHeaderAsDataStructure = _this.handleConvertTableHeaderToDataStructure(filteredTableHeaderList);
            tableHeaderAsDataStructure.map(function (eachHeader, index) {
                var _a, _b, _c, _d, _e, _f;
                var originalHeaderType = filteredTableHeaderList[index]["type"];
                if (originalHeaderType &&
                    _this.supportedHeaderType.includes(eachHeader.type)) {
                    renderAddDataList.push(react_2.default.createElement("td", { key: eachHeader.id + String(index), className: "px-4 py-4 whitespace-nowrap align-top" },
                        react_2.default.createElement("div", null, (0, display_1.renderDataTemplateForm)(_this.state.addDataValue, [eachHeader], [_this.addDataInputRefs[index]], {
                            handleOnChangeAddress: _this.handleOnChangeAddress,
                            handleOnChangeText: _this.handleOnChangeText,
                            handleOnChangeSelect: _this.handleOnChangeSelect,
                            handleOnChangeDate: _this.handleOnChangeDate,
                        }, false, undefined, undefined, {
                            dbModule: axios_1.default,
                            server: (_b = (_a = _this.props.devSettings) === null || _a === void 0 ? void 0 : _a.server) !== null && _b !== void 0 ? _b : "mongoServer",
                            dbEndpoint: (_d = (_c = _this.props.devSettings) === null || _c === void 0 ? void 0 : _c.dbEndpoint) !== null && _d !== void 0 ? _d : "",
                            dbApiToken: (_f = (_e = _this.props.devSettings) === null || _e === void 0 ? void 0 : _e.dbAPIToken) !== null && _f !== void 0 ? _f : "",
                            referencesOptions: _this.state.referencesOptions,
                            referenceLoading: _this.state.referenceLoading,
                            setReferenceLoading: _this.setReferenceLoading,
                            setReferencesOptions: _this.setReferencesOptions,
                        }))));
                }
                else {
                    renderAddDataList.push(react_2.default.createElement("td", null));
                }
                return null;
            });
            renderAddDataList.push(react_2.default.createElement("td", { className: "text-sm py-2 px-4" },
                react_2.default.createElement("div", { className: "flex flex-row gap-2" },
                    react_2.default.createElement(iconButton_1.IconButton, { icon: react_2.default.createElement(outline_1.CheckIcon, { className: "w-5 h-5 text-green-500" }), onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var completedCond;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, this.handleCheckFormInputRefs("add")];
                                    case 1:
                                        completedCond = _c.sent();
                                        if (completedCond) {
                                            if ((_a = this.props.addable) === null || _a === void 0 ? void 0 : _a.onAddData)
                                                (_b = this.props.addable) === null || _b === void 0 ? void 0 : _b.onAddData(this.state.addDataValue);
                                            this.setState({ addData: false, addDataValue: {} });
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); } }),
                    react_2.default.createElement(iconButton_1.IconButton, { icon: react_2.default.createElement(outline_1.XMarkIcon, { className: "h-5 w-5 text-red-500" }), onClick: function () { return _this.setState({ addData: false, addDataValue: {} }); } }))));
            return renderAddDataList;
        };
        _this.renderRowData = function (eachData, index) {
            var _a;
            var renderRowData = [];
            var rowId = eachData.id;
            var selectedSpaceData = null;
            if (_this.props.space) {
                try {
                    selectedSpaceData = (_a = _this.props.spaceData) === null || _a === void 0 ? void 0 : _a[index];
                }
                catch (err) { }
            }
            var filteredTableHeaderList = _this.props.header.filter(function (eachHeader) { return eachHeader.key !== "id"; });
            filteredTableHeaderList.map(function (eachHeader, colIndex) {
                var _a, _b, _c, _d;
                var value = selectedSpaceData
                    ? selectedSpaceData[eachHeader.key]
                    : eachData[eachHeader.key];
                var editRowSelected = rowId === _this.state.editDataRowId;
                var validateHeaderType = eachHeader.type && _this.supportedHeaderType.includes(eachHeader.type);
                var rowClassName = "px-6 py-4 whitespace-nowrap text-sm";
                var clickableClassName = "".concat(rowClassName, " ").concat(colIndex === 0 ? "text-primary-600 font-bold" : "text-gray-900", " ");
                if (eachHeader.groupData && eachHeader.groupData.length > 0) {
                    var element = (react_2.default.createElement("div", { className: "flex flex-row " }, (_a = eachHeader.groupData) === null || _a === void 0 ? void 0 : _a.map(function (tempData) {
                        var colData = value ? value[tempData.key] : null;
                        return (react_2.default.createElement("div", { className: "".concat(rowClassName, " text-gray-900 text-center tracking-wider w-full") }, colData
                            ? (0, display_1.renderEachRowDataBasedOnDataType)(value[tempData.key])
                            : "-"));
                    })));
                    if (_this.props.onClickRow) {
                        renderRowData.push(react_2.default.createElement("td", { key: eachHeader.key + String(index), className: clickableClassName }, _this.props.newTabUrl ? (react_2.default.createElement(link_1.Link, { href: _this.props.newTabUrl +
                                rowId +
                                ((_b = _this.props.addNewTabUrl) !== null && _b !== void 0 ? _b : ""), className: "w-full block", linkType: _this.props.linkType, custom: _this.props.custom }, element)) : (element)));
                    }
                    else {
                        renderRowData.push(react_2.default.createElement("td", { key: eachData.key + String(index) }, element));
                    }
                }
                else {
                    var data = editRowSelected ? _this.state.editDataValue : eachData;
                    if (((_c = _this.props.editable) === null || _c === void 0 ? void 0 : _c.active) && validateHeaderType) {
                        renderRowData.push(_this.renderEditDataInputs(colIndex, eachHeader, data, rowId));
                    }
                    else if (_this.props.onClickRow) {
                        renderRowData.push(react_2.default.createElement("td", { key: eachHeader.key + String(index), className: clickableClassName }, _this.props.newTabUrl ? (react_2.default.createElement(link_1.Link, { href: _this.props.newTabUrl +
                                rowId +
                                ((_d = _this.props.addNewTabUrl) !== null && _d !== void 0 ? _d : ""), className: "w-full block", linkType: _this.props.linkType, custom: _this.props.custom }, (0, display_1.renderEachRowDataBasedOnDataType)(value))) : ((0, display_1.renderEachRowDataBasedOnDataType)(value))));
                    }
                    else {
                        renderRowData.push(react_2.default.createElement("td", { key: eachHeader.key + String(index), className: "".concat(rowClassName, " text-gray-900") }, (0, display_1.renderEachRowDataBasedOnDataType)(value)));
                    }
                }
                return null;
            });
            return renderRowData;
        };
        _this.renderEditDataInputs = function (index, eachHeader, data, rowId) {
            var _a, _b, _c, _d, _e, _f, _g;
            var tempDS = __assign(__assign({}, eachHeader), { id: eachHeader.key, name: eachHeader.title, type: (_a = eachHeader.type) !== null && _a !== void 0 ? _a : "string" });
            var editingRow = _this.state.editDataRowId === rowId;
            var refs = editingRow ? [_this.editDataInputRefs[index]] : [];
            return (react_2.default.createElement("td", { key: eachHeader.key + String(index), className: "pl-6 whitespace-nowrap text-sm text-gray-900" },
                react_2.default.createElement("div", { onClick: function (e) {
                        e.stopPropagation();
                        _this.handleEditDataOnClick(rowId, eachHeader.key, data);
                    }, className: "w-max mb-1" }, (0, display_1.renderDataTemplateForm)(data, [tempDS], refs, {
                    handleOnChangeAddress: _this.handleOnChangeAddress,
                    handleOnChangeText: _this.handleOnChangeText,
                    handleOnChangeSelect: _this.handleOnChangeSelect,
                    handleOnChangeDate: _this.handleOnChangeDate,
                }, false, {
                    active: true,
                    onBlur: function () {
                        return _this.handleEditDataOnBlur(_this.state.editDataRowId, eachHeader.key, data);
                    },
                }, { id: rowId, type: "list" }, {
                    dbModule: axios_1.default,
                    server: (_c = (_b = _this.props.devSettings) === null || _b === void 0 ? void 0 : _b.server) !== null && _c !== void 0 ? _c : "mongoServer",
                    dbEndpoint: (_e = (_d = _this.props.devSettings) === null || _d === void 0 ? void 0 : _d.dbEndpoint) !== null && _e !== void 0 ? _e : "",
                    dbApiToken: (_g = (_f = _this.props.devSettings) === null || _f === void 0 ? void 0 : _f.dbAPIToken) !== null && _g !== void 0 ? _g : "",
                    referencesOptions: _this.state.referencesOptions,
                    referenceLoading: _this.state.referenceLoading,
                    setReferenceLoading: _this.setReferenceLoading,
                    setReferencesOptions: _this.setReferencesOptions,
                }))));
        };
        _this.renderPageNumber = function () {
            var _a, _b, _c, _d;
            var pageNumberList = [];
            var pageOffset = Math.floor(((_a = _this.props.pageIndex) !== null && _a !== void 0 ? _a : 0) / defaultPageSize);
            for (var i = pageOffset * defaultPageSize; i * ((_b = _this.props.limit) !== null && _b !== void 0 ? _b : defaultLimit) <
                ((_c = _this.props.size) !== null && _c !== void 0 ? _c : _this.props.data.length) &&
                i < pageOffset * defaultPageSize + defaultPageSize; i++) {
                var pageNumberClassName = "relative items-center px-3 py-2 border text-sm font-medium cursor-pointer sm:px-4";
                if (_this.props.pageIndex === i) {
                    pageNumberClassName +=
                        " z-10 bg-primary-50 border-primary-500 text-primary-600";
                }
                else {
                    pageNumberClassName +=
                        " border-gray-300 bg-white text-gray-500 hover:text-gray-500 hover:bg-gray-100 bg-white";
                }
                pageNumberList.push(react_2.default.createElement("span", { "aria-current": "page", className: pageNumberClassName, onClick: _this.props.pageIndex !== i
                        ? (_d = _this.props.handleUpdatePageIndex) === null || _d === void 0 ? void 0 : _d.bind(_this, i)
                        : function () { } }, i + 1));
            }
            return pageNumberList;
        };
        _this.renderPagination = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var paginationClassName = "relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500";
            var nextDataAvailable = ((_a = _this.props.size) !== null && _a !== void 0 ? _a : 0) >
                (((_b = _this.props.pageIndex) !== null && _b !== void 0 ? _b : 0) + 1) *
                    ((_c = _this.props.limit) !== null && _c !== void 0 ? _c : defaultLimit) || _this.props.cursor;
            switch (_this.props.paginationType) {
                case "cursor":
                    return (react_2.default.createElement("nav", { className: "relative z-0 inline-flex rounded-md shadow-sm -space-x-px", "aria-label": "Pagination" },
                        react_2.default.createElement(iconButton_1.IconButton, { disabled: _this.props.pageIndex === 0 ? true : false, icon: react_2.default.createElement(outline_1.ChevronLeftIcon, { className: "h-5 w-5", "aria-hidden": "true" }), className: "".concat(_this.props.pageIndex === 0
                                ? "cursor-not-allowed"
                                : "bg-primary-50", " ").concat(paginationClassName, " rounded-l-md"), onClick: (_d = _this.props.handleUpdatePageIndex) === null || _d === void 0 ? void 0 : _d.bind(_this, "prev") }),
                        react_2.default.createElement("span", { "aria-current": "page", className: "z-10 bg-white relative inline-flex items-center px-4 py-2 border text-sm font-medium" }, ((_e = _this.props.pageIndex) !== null && _e !== void 0 ? _e : 0) + 1),
                        react_2.default.createElement(iconButton_1.IconButton, { disabled: nextDataAvailable ? false : true, icon: react_2.default.createElement(outline_1.ChevronRightIcon, { className: "h-5 w-5", "aria-hidden": "true" }), className: "".concat(nextDataAvailable ? "bg-primary-50" : "cursor-not-allowed", " ").concat(paginationClassName, " rounded-r-md"), onClick: (_f = _this.props.handleUpdatePageIndex) === null || _f === void 0 ? void 0 : _f.bind(_this, "next") })));
                case "page":
                    return (react_2.default.createElement("nav", { className: "relative inline-flex rounded-md shadow-sm -space-x-px", "aria-label": "Pagination" },
                        react_2.default.createElement(iconButton_1.IconButton, { disabled: _this.props.pageIndex === 0 ? true : false, icon: react_2.default.createElement(outline_1.ChevronLeftIcon, { className: "h-5 w-5", "aria-hidden": "true" }), className: "".concat(_this.props.pageIndex === 0
                                ? "cursor-not-allowed"
                                : "bg-primary-50", " ").concat(paginationClassName, " rounded-l-md"), onClick: (_g = _this.props.handleUpdatePageIndex) === null || _g === void 0 ? void 0 : _g.bind(_this, ((_h = _this.props.pageIndex) !== null && _h !== void 0 ? _h : 0) - 1) }),
                        _this.renderPageNumber(),
                        react_2.default.createElement(iconButton_1.IconButton, { disabled: nextDataAvailable ? false : true, icon: react_2.default.createElement(outline_1.ChevronRightIcon, { className: "h-5 w-5", "aria-hidden": "true" }), className: "".concat(nextDataAvailable ? "bg-primary-50" : "cursor-not-allowed", " ").concat(paginationClassName, " rounded-r-md"), onClick: (_j = _this.props.handleUpdatePageIndex) === null || _j === void 0 ? void 0 : _j.bind(_this, ((_k = _this.props.pageIndex) !== null && _k !== void 0 ? _k : 0) + 1) })));
                default:
                    return react_2.default.createElement("div", null);
            }
        };
        _this.renderPageResult = function () {
            if (_this.props.paginationType === "page") {
                return "Showing ".concat(_this.props.size, " result(s)");
            }
            else {
                return "Showing ".concat(_this.props.data.length, " result(s)");
            }
        };
        return _this;
    }
    Table.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var defaultClassName = "block mx-auto flex flex-col mt-2";
        if (this.props.className) {
            defaultClassName += " ".concat(this.props.className);
        }
        return (react_2.default.createElement("div", { className: defaultClassName },
            react_2.default.createElement("div", { className: "relative align-middle min-w-full overflow-x-auto shadow bg-white sm:rounded-t-lg" },
                (this.props.selectAll ||
                    (this.props.selectedIds
                        ? this.props.selectedIds.length > 0
                        : false)) && (react_2.default.createElement("div", { className: "flex flex-row items-center" },
                    react_2.default.createElement("p", { className: "text-sm font-medium text-gray-700 py-3 px-4 sm:px-6" },
                        "Selected Items:",
                        " ",
                        this.props.selectAll
                            ? "All ".concat((_a = this.props.selectAllText) !== null && _a !== void 0 ? _a : "")
                            : (_b = this.props.selectedIds) === null || _b === void 0 ? void 0 : _b.length),
                    this.props.multiActionButton)),
                react_2.default.createElement("table", { className: "table-auto min-w-full divide-y divide-gray-200" },
                    react_2.default.createElement("thead", null,
                        react_2.default.createElement("tr", null, this.renderTableHeader())),
                    react_2.default.createElement("tbody", { className: "divide-y divide-gray-200" }, this.renderTableBody())),
                ((_c = this.props.addable) === null || _c === void 0 ? void 0 : _c.active) && !this.state.addData && (react_2.default.createElement("div", { className: "sticky left-0 w-full flex justify-center bg-white border-t border-gray-200 px-4 py-3 sm:px-6" },
                    react_2.default.createElement(textButton_1.TextButton, { text: "Create New Item", onClick: function () {
                            if (_this.handleValidateTableHeaderType(_this.props.header)) {
                                _this.setState({ addData: true });
                            }
                        }, disable: !this.handleValidateTableHeaderType(this.props.header), className: "text-sm" }))),
                !this.props.hidePagination && (react_2.default.createElement("div", { className: "sticky left-0 bg-white shadow px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6 sm:rounded-b-lg" },
                    react_2.default.createElement("div", { className: "flex-1 flex items-center justify-between" },
                        react_2.default.createElement("div", null,
                            react_2.default.createElement("p", { className: "text-sm font-medium text-gray-700" }, this.renderPageResult())),
                        this.props.paginationType && (react_2.default.createElement("div", null, this.renderPagination()))))))));
    };
    return Table;
}(react_2.Component));
exports.Table = Table;
//# sourceMappingURL=index.js.map